const isCheckboxInput = (input) => {
  return input.getAttribute('type') === 'checkbox';
};

export default [
  // Set completed to false if one of the % indexed
  // or the % DS indexed are 0.
  //
  // See discussion in https://emerge.atlassian.net/browse/SSEP-590
  {
    test: ({ item }) => (
      (
        item.indexed > 0 &&
        item.percentDataSourcesIndexed <= 0
      ) ||
      (
        item.indexed <= 0 &&
        item.percentDataSourcesIndexed > 0
      )
    ),
    value: () => false
  },

  // Enable or disable "completed" state if you click the green checkbox
  {
    test: ({ input }) => (
      isCheckboxInput(input) &&
      input.getAttribute('name') === 'completed'
    ),
    value: ({ persistedValue }) => persistedValue
  },

  // Enable "completed" state if there is log data
  {
    test: ({ item }) => (
        item.totalItems > 0 &&
        item.estimatedLogSize > 0
    ),
    value: () => true
  },

  // Disable "completed" state is there is no log data
  {
    test: ({ item }) => (
      (item.totalItems <= 0 ||
        item.estimatedLogSize <= 0)
    ),
    value: () => false
  },

  // Disable "completed if you exclude the configured item"
  {
    test: ({ input, persistedValue }) => (
      isCheckboxInput(input) &&
      input.name === 'excluded' &&
      persistedValue === true
    ),
    value: () => false
  },

  // Enable "complete" state when you include item AND there is log data
  {
    test: ({ input, item, persistedValue }) => (
      isCheckboxInput(input) &&
      input.name === 'excluded' &&
      persistedValue === false &&
      item.totalItems > 0 &&
      item.estimatedLogSize > 0 &&
      (
        (
          item.indexed === 0 &&
          item.percentDataSourcesIndexed === 0
        ) ||
        (
          item.indexed === null &&
          item.percentDataSourcesIndexed === null
        )
      )
    ),
    value: () => true
  }
];



// WEBPACK FOOTER //
// ./src/components/sources/configuredItemCompletenessRules.js